import PVForm from "../components/PVForm";

export default function NeueAnlagePage() {
  return <PVForm />;
}